// Code module route definitions.
// Mounted only when the caller's org has the code module on — DetailedShell filters via
// clientModuleRegistry.filter(enabledIds).flatMap((m) => m.routes).

import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../../client/src/components/auth/ProtectedRoute.js';

const ProjectCodeTuningPage = lazy(() => import('./pages/ProjectCodeTuningPage.js'));

export const codeRoutes: RouteObject[] = [
  {
    path: '/projects/:projectId/workstreams/:workstreamId/code',
    element: (
      <ProtectedRoute policy="CanViewProjects">
        <ProtectedRoute policy="CanViewWorkstreams">
          <ProtectedRoute policy="CanAccessProjectCode">
            <Suspense fallback={null}>
              <ProjectCodeTuningPage />
            </Suspense>
          </ProtectedRoute>
        </ProtectedRoute>
      </ProtectedRoute>
    ),
  },
];
